import { UserRound } from "lucide-react";

export default function HandoffCta({ prominent, onClick }) {
    return (
        <div
            className="px-4 pb-2 bg-[#F7F5F0] flex justify-center"
            data-testid="handoff-cta-wrap"
        >
            <button
                type="button"
                onClick={onClick}
                className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[12px] font-medium transition-colors ${
                    prominent
                        ? "bg-[#C8A24A] text-[#1A2230] hover:bg-[#b18a36] shadow-sm"
                        : "bg-white border border-[#E5DFD3] text-[#0E2A47] hover:border-[#0E2A47]"
                }`}
                data-testid="handoff-cta-button"
            >
                <UserRound className="h-3.5 w-3.5" />
                Talk to a real person
            </button>
        </div>
    );
}
